(function() {
  'use strict';

  let isInitialized = false;

  function initCheckoutButton() {
    if (isInitialized) return;
    
    const button = document.getElementById('premium-checkout-button');
    if (!button) return;

    isInitialized = true;

    button.addEventListener('click', function(e) {
      // Prevent default and stop propagation
      e.preventDefault();
      e.stopPropagation();

      // Prevent double-click
      if (button.classList.contains('is-loading')) return;

      // Add loading state
      button.classList.add('is-loading');
      button.disabled = true;

      // Trigger Meta InitiateCheckout
      if (typeof fbq === 'function') {
        fbq('track', 'InitiateCheckout');
      }

      // After 1 second, close drawer and trigger checkout
      setTimeout(function() {
        // Close cart drawer
        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && cartDrawer.close) {
          cartDrawer.close();
        }

        // Trigger Shiprocket checkout
        if (window.shiprocketCheckoutEvents && window.shiprocketCheckoutEvents.buyCart) {
          shiprocketCheckoutEvents.buyCart(e);
        }

        // Remove loading state after a short delay
        setTimeout(function() {
          button.classList.remove('is-loading');
          button.disabled = false;
        }, 500);
      }, 1000);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCheckoutButton);
  } else {
    initCheckoutButton();
  }

  // Also watch for when the cart drawer is opened (in case it's loaded dynamically)
  const observer = new MutationObserver(function() {
    initCheckoutButton();
  });

  // Start observing when document is ready
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    // If body doesn't exist yet, wait for it
    document.addEventListener('DOMContentLoaded', function() {
      if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
      }
    });
  }
})();
